/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Money_Area_NoteInputs */

const vi_my_grower_report_money_area_note = /** @type {(inputs: My_Grower_Report_Money_Area_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền nhận được tính cho cả hộ`)
};

/**

* @param {My_Grower_Report_Money_Area_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_money_area_note = /** @type {((inputs?: My_Grower_Report_Money_Area_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Money_Area_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_money_area_note(inputs)
});